export const FETCH_ALL_PROJECT_MANAGERS_REQUESTED = 'FETCH_ALL_PROJECT_MANAGERS_REQUESTED'
export const FETCH_ALL_PROJECT_MANAGERS_FAILED = 'FETCH_ALL_PROJECT_MANAGERS_FAILED'
export const FETCH_ALL_PROJECT_MANAGERS_SUCCEEDED = 'FETCH_ALL_PROJECT_MANAGERS_SUCCEEDED'